import Auth from './auth/reducers';
import { combineReducers } from 'redux';

export default combineReducers( {
	Auth,
} );
